import { Routes } from '@angular/router';
import { LayoutComponent } from './components/layout/layout.component';
import { LoginComponent } from './components/default/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { PatientsComponent } from './components/patients/patients.component';
import { AppointmentsComponent } from './components/appointments/appointments.component';
import { MedicalRecordsComponent } from './components/medical-records/medical-records.component';
import { PrescriptionsComponent } from './components/prescriptions/prescriptions.component';
import { BillingComponent } from './components/billing/billing.component';
import { UsersComponent } from './components/users/users.component';
import { AnalyticsComponent } from './components/analytics/analytics.component';
import { MessagesComponent } from './components/messages/messages.component';
import { ConsultationComponent } from './components/consultation/consultation.component';
import { PatientConsoleComponent } from './components/patient-console/patient-console.component';
import { SettingsComponent } from './components/settings/settings.component';
import { ShowcasePage1Component } from './components/showcase/showcase-page1.component';
import { ShowcasePage2Component } from './components/showcase/showcase-page2.component';
import { authGuard, loginGuard, adminLoginGuard } from './guards/auth.guard';

// Admin Components
import { AdminLoginComponent } from './components/admin/admin-login/admin-login.component';
import { AdminForgotPasswordComponent } from './components/admin/admin-forgot-password/admin-forgot-password.component';
import { AdminResetPasswordComponent } from './components/admin/admin-reset-password/admin-reset-password.component';

// Not Found Component
import { NotFoundComponent } from './components/default/not-found/not-found.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [loginGuard]
  },
  // Admin Routes
  {
    path: 'admin/login',
    component: AdminLoginComponent,
    canActivate: [adminLoginGuard]
  },
  {
    path: 'admin/forgot-password',
    component: AdminForgotPasswordComponent
  },
  {
    path: 'admin/reset-password',
    component: AdminResetPasswordComponent
  },
  {
    path: 'admin',
    loadChildren: () => import('./components/admin/admin.routes').then(m => m.adminRoutes)
  },
  // Regular App Routes
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'patients', component: PatientsComponent },
      { path: 'appointments', component: AppointmentsComponent },
      { path: 'medical-records', component: MedicalRecordsComponent },
      { path: 'prescriptions', component: PrescriptionsComponent },
      { path: 'billing', component: BillingComponent },
      { path: 'analytics', component: AnalyticsComponent },
      { path: 'messages', component: MessagesComponent },
      { path: 'consultation', component: ConsultationComponent },
      { path: 'patient-console/:patientId', component: PatientConsoleComponent },
      { path: 'users', component: UsersComponent },
      { path: 'settings', component: SettingsComponent },
      { path: 'showcase/page1', component: ShowcasePage1Component },
      { path: 'showcase/page2', component: ShowcasePage2Component }
    ]
  },
  // Wildcard route - must be last
  {
    path: '**',
    component: NotFoundComponent
  }
];
